import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { LoadContainers_ShellService } from './LoadContainers.shell.service';
import { LoadContainers_OperationService } from './LoadContainers.operation.service';
import { LoadContainers_DatasourceService } from './LoadContainers.datasource.index';
import { LoadContainers_FlowService } from './LoadContainers.flow.index';
import { LoadContainers_ReportService } from './LoadContainers.report.index';
import { LoadContainers_LocalizationService } from './LoadContainers.localization.service';
import { LoadContainers_unassigned_orders_ComponentContextService } from './LoadContainers.unassigned_orders.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './LoadContainers.frontend.types'
import { $frontendTypes as $types} from './LoadContainers.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'LoadContainers-unassigned_orders_single',
  templateUrl: './LoadContainers.unassigned_orders_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LoadContainers_unassigned_orders_singleComponent),
      multi: true
    }
  ]
})
export class LoadContainers_unassigned_orders_singleComponent extends BaseComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }


  inParams: { projectId?: number, orderTypeId?: number, fromDate?: string, toDate?: string, dateType?: string, statusIds?: number[], warehouseId?: number, ownerId?: number } = { projectId: null, orderTypeId: null, fromDate: null, toDate: null, dateType: null, statusIds: [], warehouseId: null, ownerId: null };
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('orderTypeId') set $inParams_orderTypeId(value: any) {
    this.inParams['orderTypeId'] = value;
  }
  get $inParams_orderTypeId(): any {
    return this.inParams['orderTypeId'] ;
  }
  @Input('fromDate') set $inParams_fromDate(value: any) {
    this.inParams['fromDate'] = value;
  }
  get $inParams_fromDate(): any {
    return this.inParams['fromDate'] ;
  }
  @Input('toDate') set $inParams_toDate(value: any) {
    this.inParams['toDate'] = value;
  }
  get $inParams_toDate(): any {
    return this.inParams['toDate'] ;
  }
  @Input('dateType') set $inParams_dateType(value: any) {
    this.inParams['dateType'] = value;
  }
  get $inParams_dateType(): any {
    return this.inParams['dateType'] ;
  }
  @Input('statusIds') set $inParams_statusIds(value: any) {
    this.inParams['statusIds'] = value;
  }
  get $inParams_statusIds(): any {
    return this.inParams['statusIds'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }

  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: LoadContainers_ShellService,
    private $datasources: LoadContainers_DatasourceService,
    private $flows: LoadContainers_FlowService,
    private $reports: LoadContainers_ReportService,
    private $localization: LoadContainers_LocalizationService,
    private $operations: LoadContainers_OperationService,
    private $logger: CleanupLoggerService,
    private $context: LoadContainers_unassigned_orders_ComponentContextService,
    private _elementRef: ElementRef
    ) {
    super();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  
  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val: number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }



  displayWithFn(value: any): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.LoadContainers.ds_unassigned_orders_dd.getByKeys({
        $keys: [value],
        projectId:  $selector.inParams.projectId ,
        orderTypeId:  $selector.inParams.orderTypeId ,
        fromDate:  $selector.inParams.fromDate ,
        toDate:  $selector.inParams.toDate ,
        dateType:  $selector.inParams.dateType ,
        take:  null ,
        skip:  null ,
        statusIds:  $selector.inParams.statusIds ,
        fullTextSearch:  $selector.fullTextSearch ,
        warehouseId:  $selector.inParams.warehouseId ,
        orderIds:  null ,
        ownerId:  $selector.inParams.ownerId ,
      }).then(result => {
        const found = result.result[0];
        const e: { Id?: number, CancelThresholdDate?: string, CreatedSysDateTime?: string, FulfillmentDate?: string, LookupCode?: string, ModifiedSysDateTime?: string, Notes?: string, OwnerReference?: string, ReadyToExportDate?: string, RequestedDeliveryDate?: string, VendorReference?: string, Status?: { Name?: string }, OrderClass?: { Name?: string }, Project?: { Name?: string, Owner?: { Name?: string } }, PreferredWarehouse?: { Name?: string }, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { LoadContainerSequence?: number, SealId?: string } }[] } = found ?? {};
        const $option = { entity: e };
         const $entity = e;
        const displayTextResult = found ? ($option.entity?.LookupCode + ' - ' + $option.entity?.Project.Name + ' - ' + $option.entity?.Status.Name + ' - ' + $option.entity?.OrderClass.Name + ' - ' + $utils.date.format($option.entity?.CreatedSysDateTime,'MM/DD/YY')) : 'No data to display';
        this.displayTextChange.emit(displayTextResult);
        resolve(displayTextResult);
      });

    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.LoadContainers.ds_unassigned_orders_dd.getList({
        $top: 15,
        $skip: 0,
        projectId:  $selector.inParams.projectId ,
        orderTypeId:  $selector.inParams.orderTypeId ,
        fromDate:  $selector.inParams.fromDate ,
        toDate:  $selector.inParams.toDate ,
        dateType:  $selector.inParams.dateType ,
        take:  null ,
        skip:  null ,
        statusIds:  $selector.inParams.statusIds ,
        fullTextSearch:  $selector.fullTextSearch ,
        warehouseId:  $selector.inParams.warehouseId ,
        orderIds:  null ,
        ownerId:  $selector.inParams.ownerId ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: $option.entity?.LookupCode + ' - ' + $option.entity?.Project.Name + ' - ' + $option.entity?.Status.Name + ' - ' + $option.entity?.OrderClass.Name + ' - ' + $utils.date.format($option.entity?.CreatedSysDateTime,'MM/DD/YY'), disabled: null };
            $resultOption.key = $option.entity.Id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 15
        });
      });

    });

    return promise;

  }

}
